import type { BuildServiceIntervalUpdates, ServiceIntervalUpdateRequest } from './types';

const buildServiceIntervalUpdates: BuildServiceIntervalUpdates = ({
    intervalUnits,
    intervalValues,
    parts
}) =>
    parts.reduce<ServiceIntervalUpdateRequest[]>((updates, part) => {
        const {
            assetModelPartId,
            defaultIntervalUnit,
            defaultIntervalValue,
            effectiveIntervalUnit,
            effectiveIntervalValue
        } = part;

        const intervalValue = intervalValues[assetModelPartId];
        const intervalUnit = intervalUnits[assetModelPartId] ?? effectiveIntervalUnit;

        if (!Number.isFinite(intervalValue)) {
            return updates;
        }

        if (intervalValue === effectiveIntervalValue && intervalUnit === effectiveIntervalUnit) {
            return updates;
        }

        if (intervalValue === defaultIntervalValue && intervalUnit === defaultIntervalUnit) {
            return [...updates, { assetModelPartId, reset: true }];
        }

        return [...updates, { assetModelPartId, intervalUnit, intervalValue, reset: false }];
    }, []);

export default buildServiceIntervalUpdates;
